module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleB.3a376eaa.png";